import { initSmartContentSyncClassicEditorTinyMCE } from '@adminJs/libs/editors/classicEditor/tinymceSmartContentButton';

// This file is loaded by TinyMCE via `mce_external_plugins`,
// so TinyMCE is present; we register the plugin + button immediately.
initSmartContentSyncClassicEditorTinyMCE();
